/**
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Global settings
 *
 * @exports ibmdotcom.settings
 * @type {object} Settings object
 * @property {string} [prefix=dds]
 * Carbon for IBM.com v1.24.0',
 *
 */
var settings = {
  version: 'Carbon for IBM.com v1.24.0',
  stablePrefix: 'dds'
};
export default settings;